import React from 'react';
import { PanelButton } from './SortingButtonPanel.styled';
const SortingButtonPanel = (props) => {
    const {
        label,
        width,
        height,
        backgroundColor,
        border,
        borderRadius,
        margin,
        fontSize,
        fontFamily,
        color,
        padding,
        disabled,
        clicked,
    } = props;

    return (
        <>
            <PanelButton
                width={width}
                height={height}
                backgroundColor={backgroundColor}
                border={border}
                borderRadius={borderRadius}
                margin={margin}
                color={color}
                padding={padding}
                fontSize={fontSize}
                fontFamily={fontFamily}
                disabled={disabled}
                onClick={clicked}
            >
                {label}
            </PanelButton>
        </>
    );
};
export default SortingButtonPanel;
